<template>
    <div class="loading" v-if="isLoading()"></div>
</template>

<script>
export default {
    name: "Loading"
}
</script>

<style scoped>
    .loading{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
</style>
